import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Form, Modal } from "semantic-ui-react";
import { addAdminOrganization, addOrganizationConsultor, addUser,getUsersOrganization } from "../../../../assets/api";
import ButtonSubmit from "../../../../components/Field/components/ButtonSubmit";
import Field from "../../../../components/Field/Field";
import { AuthContext } from "../../../../context/AuthContext";
import { useForm } from "../../../../hooks/useForm";


interface Props {
  isVisible: boolean;
  onClose: () => void;
  organizationCode: string;
  // onSubmit: Function;
  isCreateAdmin:boolean;
  updateConsultors: ()=>void;
  consultors:any[];
}

export default (props: Props) => {
  const { t } = useTranslation();
  const previousLength = props.consultors.length;
  
  // useEffect(()=>{
  //   console.log("HEY ITS FUCKING WORKING!!!");
  //   console.log(props.admins);
  //   console.log("!!!!!")},[props.admins]);

  if(props.isCreateAdmin)
  {  var [form, setForm, handleInputChange] = useForm({
    name:"",
    mail:"",
    code: "",
    active:true,
  });}

  else
  {
    var [form, setForm, handleInputChange] = useForm({
      code: "",
    });
  }

  const authContext = useContext(AuthContext);
  const token = authContext.account.access_token;
  const formFormated = Object.entries(form).map(([key, value]) => ({
    key,
    value,
    format: "text",
    required: true,
  }));

  return (
    <Modal
      id={"modal-add-consultor-organization"}
      size={"mini"}
      open={props.isVisible}
      onClose={props.onClose}
    >
      <Modal.Header>
        {t(`administration.assign_consultor_organization.title`)}
      </Modal.Header>
      <Modal.Content>
        <Form className="border-0" style={{ boxShadow: "none" }}>
          {formFormated.map((_: any) => {
            if (_.key=="active"){_.format="boolean"};
            return (
              <Field
                format={_.format}
                required={_.required}
                label={_.label}
                title={t(
                  `administration.assign_consultor_organization.form.${_.key}`
                )}
                name={_.key}
                value={_.value}
                onChange={handleInputChange}
                textError={t(
                  `administration.assign_consultor_organization.form.${_.key}_error`
                )}
              />
            );
          })}
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={() => {
            props.onClose();
          }}
          style={{ backgroundColor: "#cfe1ff" }}
        >
          {t("btn.cancel")}
        </Button>
        <ButtonSubmit
          title={t("administration.assign_consultor_organization.buttons.submit")}
          form={formFormated}
          handleSubmit={async () => {
            const newForm = {
              ...form,
            };
            try {
              console.log(newForm);
              const response = await addOrganizationConsultor(
                props.organizationCode,
                newForm,
                token
              );
              if (!response.ok) throw new Error("Bad Response");

              toast((
                t("administration.assign_consultor_organization.success")
              ), { type: "success"});  
              props.updateConsultors();  

              if (props.consultors.length === previousLength)
              {
                addUser(newForm,token).then(await addOrganizationConsultor(props.organizationCode,newForm,token));
                props.updateConsultors();
              }
              props.onClose();
            } catch (error) {
              toast(t("administration.assign_consultor_organization.error"), { type: "error"});
            }
          }}
        />
      </Modal.Actions>
    </Modal>
  );
};
